module.exports = __webpack_public_path__ + "assets/media/divider.8cf839e1.svg";